import { defineStore } from "pinia"
import { ref } from "vue"

export const useVersionStore = defineStore(
	"version",
	() => {
		const appVersion = ref(null)
		const migrationInProgress = ref(false)
		const migrationsDone = ref([])

		return {
			appVersion,
			migrationInProgress,
			migrationsDone,
		}
	},
	{
		persist: true,
	}
)
